export function getExploreCoordinates(exploreFieldWrapper, exploreField) {

    const oldScale = exploreField.zoomScale;


    const oldLeft = exploreField.leftPos;
    const oldTop = exploreField.topPos;

    const x = (oldLeft - exploreField.offsetWidth/2*(1-oldScale))/oldScale;
    const y = (oldTop - exploreField.offsetHeight/2*(1-oldScale))/oldScale;
    

    return {
        x: x,
        y: y
    };

}

export function moveExploreToCoordinates(exploreFieldWrapper, exploreField, x=null, y=null) {
    
    const zoomLevel = exploreField.zoomScale;

    const coordinates = getExploreCoordinates(exploreFieldWrapper, exploreField);

    const xOld = coordinates.x;
    const yOld = coordinates.y;

    const oldLeft = exploreField.leftPos;
    const oldTop = exploreField.topPos;

    let leftPos = oldLeft + (x-xOld) * zoomLevel;
    let topPos = oldTop + (y-yOld) * zoomLevel;
    

    moveExploreFieldTo(exploreFieldWrapper, exploreField, leftPos, topPos);
}


//leftPos = position of the visible frame from the left of the field; topPos = position of the visible frame from the top of the field
export function moveExploreFieldTo(exploreFieldWrapper, exploreField, leftPos=null, topPos=null) {

    
    const minZoomValue = exploreField.minZoomValue;
    const maxZoomValue = exploreField.maxZoomValue;

    const zoomLevel = exploreField.zoomScale;

    const horizontalFreedom = exploreField.offsetWidth - exploreFieldWrapper.offsetWidth;
    const verticalFreedom = exploreField.offsetHeight - exploreFieldWrapper.offsetHeight;

    const horizontalLimitAtMin = exploreField.offsetWidth/2 * (1-zoomLevel);
    const horizontalLimitAtMax = horizontalLimitAtMin + exploreField.horizontalPadding * zoomLevel;
    const verticalLimitAtMin = exploreField.offsetHeight/2 * (1-zoomLevel);
    const verticalLimitAtMax = verticalLimitAtMin + exploreField.verticalPadding * zoomLevel;

    const additionalHorizontalLimit = (horizontalLimitAtMax-horizontalLimitAtMin)/(maxZoomValue-minZoomValue) * (zoomLevel-minZoomValue) + horizontalLimitAtMin;
    const additionalVerticalLimit = (verticalLimitAtMax-verticalLimitAtMin)/(maxZoomValue-minZoomValue) * (zoomLevel-minZoomValue) + verticalLimitAtMin;
    
    let limitCoefficient = 1;

    if(zoomLevel>1)
        limitCoefficient = Math.log2(1/zoomLevel)/2;

    if(leftPos!==null) {
        leftPos = -leftPos;

        if(leftPos>0-additionalHorizontalLimit) {
            leftPos = 0-additionalHorizontalLimit;
        } else if(leftPos<additionalHorizontalLimit-horizontalFreedom) {
            leftPos = additionalHorizontalLimit-horizontalFreedom;
        }

        exploreField.style.left = leftPos + 'px';
        exploreField.leftPos = -leftPos;
    }

    if(topPos!==null) {
        topPos = -topPos;
        
        if(topPos>0-additionalVerticalLimit) {
            topPos = 0-additionalVerticalLimit;
        } else if(topPos<additionalVerticalLimit-verticalFreedom) {
            topPos = additionalVerticalLimit-verticalFreedom;
        }

        exploreField.style.top = topPos + 'px';
        exploreField.topPos = -topPos;
    }
    

}

export function centerExploreFieldAroundTheBranch(exploreFieldWrapper, branchId) {

    const exploreField = exploreFieldWrapper.exploreField;

    console.log("explore dictionary", exploreField.exploreBranchesDictionary);

    if(exploreField.exploreBranchesDictionary===null || exploreField.exploreBranchesDictionary===undefined)
        return null;

    const branch = exploreField.exploreBranchesDictionary[branchId];

    const offsetLeftTotal = getOffsetLeftRelativeTo(branch, exploreField);
    const offsetTopTotal = getOffsetTopRelativeTo(branch, exploreField);
    
    let newLeft = offsetLeftTotal - exploreFieldWrapper.offsetWidth/2 + branch.offsetWidth/2;
    //let newTop = -(offsetTopTotal - exploreFieldWrapper.offsetHeight/2 +  branch.offsetHeight/2);
    let newTop = offsetTopTotal;

    if(newLeft>exploreField.offsetWidth-exploreFieldWrapper.offsetWidth){
        newLeft = (-exploreFieldWrapper.offsetWidth) + branch.offsetWidth/2;}

    if(newTop>exploreField.offsetHeight-exploreFieldWrapper.offsetHeight) {
        console.log("haha vertical");
        
        //newTop = newTop + branch.offsetHeight/2;
        newTop = newTop + branch.offsetHeight;

    }
    
    exploreFieldWrapper.moveExploreFieldTo(newLeft, newTop);
}

export function goToBranch(exploreFieldWrapper, exploreField, branchId) {
    const zoomLevel = exploreField.zoomScale;

    const branch = exploreField.exploreBranchesDictionary[branchId];

    const offsetLeftTotal = getOffsetLeftRelativeTo(branch, exploreField);
    const offsetTopTotal = getOffsetTopRelativeTo(branch, exploreField);

    const newLeft = offsetLeftTotal * (1-zoomLevel);
    const newTop = offsetTopTotal * (1-zoomLevel);
    

    moveExploreToCoordinates(exploreFieldWrapper, exploreField, offsetLeftTotal, offsetTopTotal);
}

export function goToBranchWithDistanceToScreen(exploreFieldWrapper, exploreField, branchId, distanceLeft, distanceTop) {
    const zoomLevel = exploreField.zoomScale;

    const branch = exploreField.exploreBranchesDictionary[branchId];

    const offsetLeftTotal = getOffsetLeftRelativeTo(branch, exploreField);
    const offsetTopTotal = getOffsetTopRelativeTo(branch, exploreField);

    const newLeft = (offsetLeftTotal * zoomLevel - distanceLeft) + exploreField.offsetWidth/2*(1-zoomLevel);
    const newTop = (offsetTopTotal * zoomLevel - distanceTop) + exploreField.offsetHeight/2*(1-zoomLevel);

    moveExploreFieldTo(exploreFieldWrapper, exploreField, newLeft, newTop);
    
}

export function getBranchDistanceToScreen(exploreField, branchId) {
    const leftPos = exploreField.leftPos;
    const topPos = exploreField.topPos;

    const zoomLevel = exploreField.zoomScale;

    const branch = exploreField.exploreBranchesDictionary[branchId];

    const offsetLeftTotal = getOffsetLeftRelativeTo(branch, exploreField);
    const offsetTopTotal = getOffsetTopRelativeTo(branch, exploreField);

    const distanceLeft = offsetLeftTotal*zoomLevel - (leftPos-exploreField.offsetWidth/2*(1-zoomLevel));
    const distanceTop = offsetTopTotal*zoomLevel - (topPos-exploreField.offsetHeight/2*(1-zoomLevel));

    return {
        distanceLeft : distanceLeft,
        distanceTop : distanceTop
    };
}


function getExplorePointOnTheScreen(exploreField, leftScreenCoord, topScreenCoord) {
    const leftPos = exploreField.leftPos;
    const topPos = exploreField.topPos;
    const scale = exploreField.zoomScale;

    const offsetLeft = (leftPos + leftScreenCoord - exploreField.offsetWidth/2*(1-scale))/scale;
    const offsetTop = (topPos + topScreenCoord - exploreField.offsetHeight/2*(1-scale))/scale;

    return {
        offsetLeft : offsetLeft,
        offsetTop : offsetTop
    }
}

function getExplorePointOnTheScreenFromCenter(exploreFieldWrapper, exploreField, xCoord, yCoord) {

    return getExplorePointOnTheScreen(exploreField, exploreFieldWrapper.offsetWidth/2 + xCoord, exploreFieldWrapper.offsetHeight/2 + yCoord);
}

export function getClosestBranchToScreen(exploreFieldWrapper, exploreField) {
    const branchDictionary = exploreField.exploreBranchesDictionary;

    const screenCentreOffset = getExplorePointOnTheScreenFromCenter(exploreFieldWrapper, exploreField, 0, 0);

    const closestBranch = {};

    closestBranch.distance = Math.max(exploreField.offsetHeight, exploreField.offsetWidth, 0);

    for(const [branchId, branchElement] of Object.entries(branchDictionary)) {
        const distanceToBranchCentre = ExploreMovementUtility.getElementCentreCoordinates(exploreField, branchElement);

        const distance = Math.sqrt((screenCentreOffset.offsetLeft-distanceToBranchCentre.offsetLeft)**2
            + (screenCentreOffset.offsetTop-distanceToBranchCentre.offsetTop)**2);

        if(distance<closestBranch.distance) {
            closestBranch.distance = distance;
            closestBranch.branchId = branchId;
            closestBranch.branchElement = branchElement;
        }
    }

    return closestBranch;
}

function getOffsetLeftRelativeTo(targetElement, containerElement) {
    let offset = 0;
    let current = targetElement;
  
    while (current && current !== containerElement) {
      offset += current.offsetLeft;
      current = current.offsetParent;
    }
  
    // If we never found the containerElement in the offsetParent chain
    if (current !== containerElement) {
      console.warn('Container not found in offsetParent chain.');
      return null;
    }
  
    return offset;
}

function getOffsetTopRelativeTo(targetElement, containerElement) {
    let offset = 0;
    let current = targetElement;
  
    while (current && current !== containerElement) {
      offset += current.offsetTop;
      current = current.offsetParent;
    }
  
    // If we never found the containerElement in the offsetParent chain
    if (current !== containerElement) {
      console.warn('Container not found in offsetParent chain.');
      return null;
    }
  
    return offset;
}

export function scaleExploreField(exploreField, scale) {
    if(scale<=0)
        return false;

    const minZoomValue = exploreField.minZoomValue;
    const maxZoomValue = exploreField.maxZoomValue;

    if (scale<=minZoomValue) {
        scale = minZoomValue;
    } else if(scale>=maxZoomValue) {
        scale = maxZoomValue;
    }

    exploreField.style.transform = `scale(${scale})`;
    exploreField.zoomScale = scale;

    const scaleControllerInput = exploreField.zoomController;
    scaleControllerInput.value = scale;
}

export function scaleExploreFieldBy(exploreField, scaleChange) {
    if(exploreField.zoomScale===null || exploreField.zoomScale===undefined)
        exploreField.zoomScale = 1;

    const newScale = exploreField.zoomScale * scaleChange;

    //console.log("scaleExploreFieldBy: ", exploreField.zoomScale, scaleChange);
    

    scaleExploreField(exploreField, newScale);
}
/*
function checkScaleAgainstBaseDimensions(exploreField, scale) {
    if(scale<=0)
        return false;

    const minZoomValue = exploreField.minZoomValue;
    const maxZoomValue = exploreField.maxZoomValue;

    if(scale<minZoomValue){
        exploreField.scaleExploreField(minZoomValue);
        return false;
    }

    if(scale>maxZoomValue){
        exploreField.scaleExploreField(maxZoomValue);
        return false;
    }

    return true;
}
    */

class ExploreMovementUtility {

    static getOffsetLeftRelativeTo(targetElement, containerElement) {
        let offset = 0;
        let current = targetElement;
    
        while (current && current !== containerElement) {
            offset += current.offsetLeft;
            current = current.offsetParent;
        }
  
        // If we never found the containerElement in the offsetParent chain
        if (current !== containerElement) {
            console.warn('Container not found in offsetParent chain.');
            return null;
        }
  
        return offset;
    }

    static getOffsetTopRelativeTo(targetElement, containerElement) {
        let offset = 0;
        let current = targetElement;
    
        while (current && current !== containerElement) {
            offset += current.offsetTop;
            current = current.offsetParent;
        }
    
        // If we never found the containerElement in the offsetParent chain
        if (current !== containerElement) {
            console.warn('Container not found in offsetParent chain.');
            return null;
        }
    
        return offset;
    }

    static getElementCentreCoordinates(explroeField, element) {
        const offsetLeft = this.getOffsetLeftRelativeTo(element, explroeField);
        const offsetTop = this.getOffsetTopRelativeTo(element, explroeField);

        return {
            offsetLeft : offsetLeft + element.offsetWidth/2,
            offsetTop : offsetTop + element.offsetHeight/2
        }
    }
}